import { render, staticRenderFns } from "./TooltipInformativo.vue?vue&type=template&id=96a252ba&scoped=true"
import script from "./TooltipInformativo.vue?vue&type=script&lang=js"
export * from "./TooltipInformativo.vue?vue&type=script&lang=js"
import style0 from "./TooltipInformativo.vue?vue&type=style&index=0&id=96a252ba&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a252ba",
  null
  
)

export default component.exports